import React, { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import DropDownsAHSF from "../../../Components/DropdownsAHSF";
import AddAplicatoionInformation from "../../../Services/ApplicationInformation/AddAplicationInformation";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import shouldDisableFields from "./OtherMainSubSectorsTable";

import GetAplicantInformation from "../../../Services/ApplicantInformationPage/GetApplicantInformationData";
import { useDispatch } from "react-redux";
import moment from "moment-timezone";
import { useSelector } from "react-redux";
import LoaderAHSF from "../../../Components/LoaderAHSF";
import {
  GetAllAI_GrantsProgram,
  GetAllAI_MainSector,
  GetAllAI_SubSector,
  GetAllAI_SupportProgramsName,
} from "../../../Redux/Reducers/DropDownApplicationInformation";
import {
  setrefreshApplicationInformation,
  setRefreshTable,
} from "../../../Redux/Reducers/VariousVariables";
import {
  SetApplicationInformation,
  UpdateAI_GrantsProgram,
  UpdateMainSector,
} from "../../../Redux/Reducers/ApplicationInformation";
import Swal from "sweetalert2";
import { DeleteListAI_SecondarySectors } from "../../../Redux/Reducers/SecondarySectors";
import PopupAHSF from "../../../Components/PopupAHSF";
import $ from "jquery";
import OtherMainSubSectorsTable from "./OtherMainSubSectorsTable";
import { useParams } from "react-router-dom";
import { decryptToken } from "../../../Services/Account/EncryptionParams";
import loadConfig from "../../../Services/apiService";
const ApplicatnInformation = (props) => {
  const dispatch = useDispatch();
  const AppGuid = useParams();
  const [refreshDataProgram, setrefreshDataProgram] = useState(0);
  const [refreshDataMainSector, setrefreshDataMainSector] = useState(0);
  const [dataJsonObject, SetDataJsonObject] = useState();
  const state = useSelector((state) => {
    return {
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
      loadingApplicationInformation:
        state.ApplicationInformation.loadingApplicationInformation,
      AI_GrantsProgram: state.dropDownApplicationInformation.AI_GrantsProgram,
      AI_MainSector: state.dropDownApplicationInformation.AI_MainSector,
      SubSector: state.dropDownApplicationInformation.SubSector,
      ApplicationInformationValidationPage:
        state.ApplicationInformationValidationPage
          .ApplicationInformationValidationPage,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      loadingAI_GrantsProgram:
        state.dropDownApplicationInformation.loadingAI_GrantsProgram,
      loadingAI_MainSector:
        state.dropDownApplicationInformation.loadingAI_MainSector,
    };
  });

  const [
    InformationAboutProjectUpdateData,
    setInformationAboutProjectUpdateData,
  ] = useState({
    ...state.ApplicationInformation,
  });

  //[,]
  //to get dropdowns data
  useEffect(() => {
    dispatch(GetAllAI_GrantsProgram());
    // dispatch(GetAllAI_MainSector());
    // dispatch(GetAllAI_SubSector(state.ApplicationInformation?.aI_MainSectorId));
  }, [refreshDataProgram]);

  useEffect(() => {
    // This effect runs when either `state.ApplicationInformation.aI_GrantsProgramId` or `refreshDataMainSector` changes.
    // Dispatch an action to get all the main sectors for a given grants program ID.
    dispatch(
      GetAllAI_MainSector(state.ApplicationInformation?.aI_GrantsProgramId)
    );
  }, [state.ApplicationInformation?.aI_GrantsProgramId, refreshDataMainSector]);
  // Dependency array: Runs when either `state.ApplicationInformation.aI_GrantsProgramId` or `refreshDataMainSector` changes.

  useEffect(() => {
    // This effect runs once when the component mounts.
    // Dispatch an action to get all the sub-sectors for a given main sector ID (only on initial load).
    dispatch(GetAllAI_SubSector(state.ApplicationInformation?.aI_MainSectorId));
  }, []);
  // Dependency array: Empty, meaning this effect runs only once after the initial render.

  useEffect(() => {
    // This effect runs when `state.ApplicationInformation.aI_MainSectorId` changes.
    // Dispatch an action to get the sub-sectors when the main sector ID changes.
    dispatch(GetAllAI_SubSector(state.ApplicationInformation?.aI_MainSectorId));
  }, [state.ApplicationInformation?.aI_MainSectorId]);
  // Dependency array: Runs when `state.ApplicationInformation.aI_MainSectorId` changes.

  //[,]
  //to save data on reducer after any change on InformationAboutProjectUpdateData
  useEffect(() => {
    dispatch(
      SetApplicationInformation({ ...InformationAboutProjectUpdateData })
    );
  }, [InformationAboutProjectUpdateData]);
  //to check on grants program change to show confirmation popup to handel changes
  const dataJson = async () => {
    let jsonData = await loadConfig();
    SetDataJsonObject(jsonData);
    //console.log(jsonData, "jsonData");
  };
  useEffect(() => {
    dataJson();
  }, []);
  const onGrantsProgramChange = (e) => {
    if (state.ApplicationInformation?.aI_GrantsProgramId) {
      Swal.fire({
        title: dataJsonObject?.PopuPtitel_?.nameAR,
        text: dataJsonObject?.confermPopuPGrantsProgram?.nameAR,
        // icon: "question",
        // iconHtml: "؟",
        confirmButtonText: "تأكيد",
        cancelButtonText: "الغاء",
        showCancelButton: true,
        showCloseButton: true,
        customClass: {
          confirmButton: "sweetalertBtn",
          cancelButton: "closeBtnSweet",
        },
      }).then(async (res) => {
        if (res.isConfirmed == true) {
          const deleted = await dispatch(
            DeleteListAI_SecondarySectors(
              localStorage.getItem("aI_ApplicationInformationId") ||
                decryptToken(AppGuid.AppGuid)
            )
          );
          setInformationAboutProjectUpdateData({
            ...InformationAboutProjectUpdateData,
            aI_GrantsProgramId: parseInt(e.target.value), // التحديث هنا
            aI_MainSectorId: null, // التحديث هنا
            aI_SubSectorId: null,
          });
          //console.log(deleted,"deleted");

          if (deleted) {
            dispatch(setRefreshTable());
          }
          dispatch(
            UpdateAI_GrantsProgram({
              aI_ApplicationInformationId: localStorage.getItem(
                "aI_ApplicationInformationId"
              ),
              aI_GrantsProgramId: parseInt(e.target.value),
            })
          );
        } else if (res.isDismissed == true) {
          setInformationAboutProjectUpdateData({
            ...InformationAboutProjectUpdateData,
            aI_GrantsProgramId: state.ApplicationInformation.aI_GrantsProgramId, // التحديث هنا
          });
          setrefreshDataProgram(refreshDataProgram + 1);
        }
      });
    } else {
      setInformationAboutProjectUpdateData({
        ...InformationAboutProjectUpdateData,
        aI_GrantsProgramId: parseInt(e.target.value), // التحديث هنا
      });
      dispatch(
        UpdateAI_GrantsProgram({
          aI_ApplicationInformationId: localStorage.getItem(
            "aI_ApplicationInformationId"
          ),
          aI_GrantsProgramId: parseInt(e.target.value),
        })
      );
    }
  };
  //to check on main sector change to show confirmation popup to handel changes
  const onMainsectorProjectChange = (e) => {
    if (state.ApplicationInformation?.aI_MainSectorId) {
      Swal.fire({
        title: dataJsonObject?.PopuPtitel_?.nameAR,
        text: dataJsonObject?.confermPopuPMainSector?.nameAR,
        // icon: "question",
        // iconHtml: "؟",
        confirmButtonText: "تأكيد",
        cancelButtonText: "الغاء",
        showCancelButton: true,
        showCloseButton: true,
        customClass: {
          confirmButton: "sweetalertBtn",
          cancelButton: "closeBtnSweet",
        },
      }).then(async (res) => {
        if (res.isConfirmed == true) {
          setInformationAboutProjectUpdateData({
            ...InformationAboutProjectUpdateData,
            aI_MainSectorId: parseInt(e.target.value), // التحديث هنا
            aI_SubSectorId: null,
          });
        } else if (res.isDismissed == true) {
          setInformationAboutProjectUpdateData({
            ...InformationAboutProjectUpdateData,
            aI_MainSectorId: state.ApplicationInformation.aI_MainSectorId, // التحديث هنا
          });
          setrefreshDataMainSector(refreshDataMainSector + 1);
        }
      });
    } else {
      setInformationAboutProjectUpdateData({
        ...InformationAboutProjectUpdateData,
        aI_MainSectorId: parseInt(e.target.value), // التحديث هنا
      });
    }
  };

  // مابقدر يعدل اذا ماكانت الدورة فعالة او managerالحالة قيد المراجة او الدخول من ال

  if (
    state.ActiveRound != state.ApplicationInformation?.aI_RoundYearId &&
    state.ApplicationInformation?.aI_ApplicationStatus?.canEdite != true &&
    window.location.href.includes("manager") != false
  ) {
    $(".form-grid input").attr("disabled", true);
    $(".form-grid select").attr("disabled", true);
    $(".form-grid textarea").attr("disabled", true);
    $(".form-grid input").css("background-color", "#F1F1F1");
    $(".form-grid input").css("cursor", "not-allowed");
  }





  const shouldDisableFields = !(
    state.ApplicationInformation?.aI_ApplicationStatusId === "bbad6edf-0d73-4478-b33d-68f9c777d438"&&!window.location.href.includes("manager") ? true :
      state.ActiveRound === state.ApplicationInformation?.aI_RoundYearId &&
      state.ApplicationInformation?.aI_ApplicationStatus?.canEdite &&
      !window.location.href.includes("manager")
  );
console.log(state.ApplicationInformation,"nnnnnnssd");

  //if loding ends render html
  return !state.loadingApplicationInformation &&

    !state.loadingAI_GrantsProgram &&
    !state.loadingAI_MainSector ? (
    <>
      <div className="form-grid">
        <InputAHSF
          fieldsName="ApplicationNumberInput"
          show={true}
          disabled={true}
          // showValidationMessage={true}
          // validationMessage="يرجى تعبئة هذا الحقل"
          value={state.ApplicationInformation?.applicationNumber}
          showValidationMessage={false}
        />
        <InputAHSF
          fieldsName="ApplicationStatusInput"
          show={true}
          disabled={true}
          // showValidationMessage={true}
          // validationMessage="يرجى تعبئة هذا الحقل"
          value={state.ApplicationInformation?.statusNameAr}
        />
        <InputAHSF
          fieldsName="RequestCreationDateInput"
          show={true}
          disabled={true}
          // showValidationMessage={true}
          // validationMessage="يرجى تعبئة هذا الحقل"
          value={moment(state.ApplicationInformation?.creationDate).format(
            "DD/MM/YYYY h:mm a"
          )}
        />
        <AllDropDownsAHSF
          fieldsName="SupportProgram"
          show={true}
          disabled={shouldDisableFields}
          // showValidationMessage={true}
          // validationMessage="يرجى تعبئة هذا الحقل"
          onChange={(e) => {
            onGrantsProgramChange(e);
          }}
          defaultValue={state.ApplicationInformation?.aI_GrantsProgramId}
          arrayOoptionList={state.AI_GrantsProgram}
          KeyText={"grantsProgramNameAr"}
          KeyValue={"aI_GrantsProgramId"}
          dropdownType={"normal"}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "SupportProgram"
                )
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <AllDropDownsAHSF
          fieldsName="MainsectorProject"
          show={true}
          disabled={shouldDisableFields}
          // showValidationMessage={true}
          // validationMessage="يرجى تعبئة هذا الحقل"
          onChange={(e) => {
            onMainsectorProjectChange(e);
          }}
          defaultValue={state.ApplicationInformation?.aI_MainSectorId}
          arrayOoptionList={state.AI_MainSector}
          KeyText={"mainSectorAr"}
          KeyValue={"aI_MainSectorId"}
          dropdownType={"normal"}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "MainsectorProject"
                )
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
        <AllDropDownsAHSF
          fieldsName="subSectorProject"
          dropId="dropId"
          show={true}
          disabled={shouldDisableFields}
          // showValidationMessage={true}
          // validationMessage="يرجى تعبئة هذا الحقل"
          onChange={(e) => {
            setInformationAboutProjectUpdateData({
              ...InformationAboutProjectUpdateData,
              aI_SubSectorId: parseInt(e.target.value), // التحديث هنا
            });
          }}
          defaultValue={state.ApplicationInformation?.aI_SubSectorId}
          arrayOoptionList={state.SubSector}
          KeyText={"aI_SubSectorAr"}
          KeyValue={"aI_SubSectorId"}
          dropdownType={"normal"}
          showValidationMessage={
            state.ApplicationInformationValidationPage
              ? state.ApplicationInformationValidationPage.includes(
                  "subSectorProject"
                )
              : false
          }
          validationMessage="يرجى تعبئة هذا الحقل"
        />
      </div>
      <OtherMainSubSectorsTable />
    </>
  ) : (
    ""
  );
};

export default ApplicatnInformation;
